import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { DashboardDimensionFilterDropdown } from './DashboardDimensionFilterDropdowns/DashboardDimensionFilterDropdown'

// Risk-category values come from the category dim stamped on the risk metrics.
export const DashboardRiskCategoryFilterDropdown = ({
  isNested = false,
  dashboardContext,
  dashboardName,
}: {
  isNested?: boolean
  dashboardContext?: DASHBOARD_CONTEXT
  dashboardName?: string
}): JSX.Element | null => {
  if (dashboardContext === undefined || dashboardName === undefined) {
    return null
  }

  return (
    <DashboardDimensionFilterDropdown
      isNested={isNested}
      filterParam={FilterParam.DASHBOARD_RISK_CATEGORY}
      filterName={FilterName.DASHBOARD_RISK_CATEGORY}
      dashboardContext={dashboardContext}
      dashboardName={dashboardName}
      dimension="category"
    />
  )
}
